import { Route, Routes } from 'react-router-dom'

import Details from './screens/Details'

const PaginationRuleEditRoutes = () => (
  <Routes>
    <Route index element={<Details />} />
  </Routes>
)

export default PaginationRuleEditRoutes
